import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '@core/services/core/base.service';
import { OperationRegisterService } from '@core/services/core/operation-register.service';
import { CheckAvailabilityResponse, IdentifyClientResponse } from '@models/genesys-chat';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GenesysChatService {

  constructor(
    private http: HttpClient,
    private base: BaseService,
    private ro: OperationRegisterService
  ) {
  }

  identifyClient(): Observable<IdentifyClientResponse>{
    const url = `${this.base.getPrivateOIMBaseUrl()}/clients/chat/customer/identification`;
    const headers = this.base.getPrivateOIMHeaders();
    const params = this.ro.getChatUrlQueryParams();

    return this.http.get<IdentifyClientResponse>(url, { ...headers, params });
  }

  checkAvailability(managerId: string): Observable<CheckAvailabilityResponse>{
    const url = `${this.base.getPrivateOIMBaseUrl()}/clients/chat/${managerId}/status`;
    const headers = this.base.getPrivateOIMHeaders();
    const params = this.ro.getChatUrlQueryParams();
    return this.http.get<CheckAvailabilityResponse>(url, { ...headers, params });
  }

}
